import React, { useEffect } from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import AOS from 'aos';
import 'aos/dist/aos.css';



const sections = [
  {
    title: '¿Qué somos?',
    text: 'Somos una plataforma web enfocada en digitalizar el historial médico de estudiantes de nivel básico y medio superior, facilitando el seguimiento médico escolar.',
  },
  {
    title: '¿Quiénes somos?',
    text: 'Un equipo comprometido con la salud y educación de niños y jóvenes, buscando modernizar la manera en que se gestiona la información médica en entornos escolares.',
  },
  {
    title: '¿Qué hacemos?',
    text: 'Permitimos que padres, médicos y escuelas accedan a información médica segura, actualizada y accesible, para mejorar la atención y prevención en la salud estudiantil.',
  },
];

const AboutSection = () => {

    useEffect(() => {
        AOS.init({
            duration: 1000, // duración de la animación en ms
            once: true      // solo se anima una vez
        });
    }, []);


    return (
        <Box sx={{ px: 4, py: 8, backgroundColor: '#f5f5f5' }}>
        <Grid container spacing={4}>
            {sections.map((item, index) => (
            <Grid 
                item 
                xs={12} 
                md={4} 
                key={index}   
                data-aos="fade-up"            // 👈 Aquí se aplica la animación
                data-aos-delay={index * 100} // animación escalonada
            >
                <Paper
                elevation={0}
                sx={{
                    p: 4,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    borderRadius: 0,

                }}
                >
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    {item.title}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    {item.text}
                </Typography>
                </Paper>
            </Grid>
            ))}
        </Grid>
        </Box>
    );
};

export default AboutSection;
